import {IConfigSchema,} from '@/containers/FdcMilanoVolunteers/resources/config-schema';
import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';
import {getIndicators} from './calculations';

export const configSchema = (submissions: ISubmissionProps[]): IConfigSchema => ({
    title: 'III. LIVELLO DI SODDISFAZIONE DEI VOLONTARI PER LE ATTIVITA’ FORMATIVE',
    tooltip: 'Il visual mostra il livello di soddisfazione dei volontari per le attività formative ricevute nell’ambito del progetto “Indovina chi viene a casa”. Il valore è pari alla percentuale di volontari che si dichiara soddisfatto dei moduli formativi (in termini di utilità sia per lo svolgimento delle attività sia per l’interazione con i beneficiari), secondo la “Scheda di Monitoraggio per la rilevazione della soddisfazione dei volontari”. Tale valore viene confrontato con il valore atteso che il progetto prevede di raggiungere (70%).',
    type: 'column',
    categories: ['Percentuale di volontari soddisfatti dei moduli formativi'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: [getIndicators(submissions)]
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [70]
        },
    ],
});